<template>
  <div class="contact">
    <b-container>
      <div class="page-title text-center py-5">
        <h1>Contact <span>us</span></h1>
      </div>
    </b-container>

    <b-container class="mb-5">
      <b-row>
        <b-col md="6" class="mb-5 mb-md-0">
          <div class="block">
              <h3>Contact details</h3>
              <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium,totam. Rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                voluptas sit aspernatur aut odit aut fugit.
              </p>
              <p>
                <font-awesome-icon
                  :icon="['fas', 'phone']"
                  class="mr-2"
                ></font-awesome-icon>
                +43 664 280 20 10
              </p>
              <p>
                <font-awesome-icon
                  :icon="['fas', 'envelope']"
                  class="mr-2"
                ></font-awesome-icon>
                info@growthlabs.com
              </p>
            </div>
          <b-img fluid src="@/assets/email-isometric.png" width="600"></b-img>
        </b-col>
        <b-col md="4" offset-md="2">
          <contact-form></contact-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ContactForm from "@/components/ContactForm";

export default {
  name: "Contact",
  components: {
    ContactForm
  }
};
</script>

<style lang="scss" scoped>
.page {
  &-title {
    h1 {
      &:before {
        content: "CONTACT";
      }
    }
  }
}

svg {
  color: $yellow;
}
</style>
